import { Boxes, FlaskConical } from "lucide-react";
import type { CiTestType } from "@/lib/types";
import { cn } from "@/lib/utils";

interface TestTypeBadgeProps {
  type: CiTestType;
  className?: string;
}

const typeMeta: Record<CiTestType, { label: string; icon: typeof FlaskConical; tint: string }> = {
  criu: {
    label: "CRIU",
    icon: FlaskConical,
    tint: "text-primary border-primary/30 bg-primary/5",
  },
  cryod: {
    label: "Cryod K8s",
    icon: Boxes,
    tint: "text-emerald-500 border-emerald-500/40 bg-emerald-500/5",
  },
};

export function TestTypeBadge({ type, className }: TestTypeBadgeProps) {
  const meta = typeMeta[type];
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium uppercase tracking-wide",
        meta.tint,
        className,
      )}
    >
      <Icon className="size-3" />
      {meta.label}
    </span>
  );
}
